import { useCallback } from 'react'
import { toast } from 'react-toastify'

export default ({ history, deleteRecipe, setShowDeleteModal }) => {

  const onDelete = useCallback(
    item => deleteRecipe(item.id).then(() => {
      toast.success(`Recipe '${item.name}' deleted`, {
        position: toast.POSITION.TOP_RIGHT,
      })
    }),
    [deleteRecipe],
  )

  const handleDelete = useCallback(
    item => setShowDeleteModal(item),
    [setShowDeleteModal],
  )

  const onEdit = useCallback(
    item => {
      history.push(`/recipes/${item.id}`)
    },
    [history],
  )

  return {
    onDelete,
    onEdit,
    handleDelete,
  }
}
